// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
//
const firebaseConfig = {
    apiKey: "AIzaSyCrpGv9yiLgU_DVTJ87SFcD_pFGTiJFkqk",
    authDomain: "corporacion-cessa-colombia.firebaseapp.com",
    projectId: "corporacion-cessa-colombia",
    storageBucket: "corporacion-cessa-colombia.firebasestorage.app",
    messagingSenderId: "60942486668",
    appId: "1:60942486668:web:fa6f6a82cd6dd7d9ed7fa9",
    measurementId: "G-PBPKCEC78D"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)